module.exports = __webpack_public_path__ + "static/img/title-4.e3214ba3.svg";